(() => {
    const cache = new Map();

    async function loadSvg(url) {
        if (cache.has(url)) return cache.get(url);

        const p = fetch(url, { credentials: "same-origin" })
            .then(r => {
                if (!r.ok) throw new Error(`Failed to load SVG: ${url}`);
                return r.text();
            })
            .then(text => {
                // Extract just the <svg ...>...</svg>
                const match = text.match(/<svg[\s\S]*<\/svg>/i);
                if (!match) throw new Error(`No <svg> found in: ${url}`);
                return match[0];
            });

        cache.set(url, p);
        return p;
    }

    async function hydrate(el) {
        const url = el.dataset.mbIconUrl;
        if (!url || el.dataset.mbIconHydrated === "true") return;
        try {
            const svgMarkup = await loadSvg(url);

            // Surgical injection:
            el.innerHTML = svgMarkup;

            const svg = el.querySelector("svg");
            if (svg) {
                svg.setAttribute("focusable", "false");
                svg.setAttribute("aria-hidden", "true"); // Inner SVG should be hidden as span has the role
            }

            el.dataset.mbIconHydrated = "true";
        } catch (e) {
            console.error("Hydration error:", url, e);
        }
    }

    function init(root = document) {
        root.querySelectorAll("[data-mb-icon]").forEach(hydrate);
    }

    // Initial load
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => init());
    } else {
        init();
    }

    window.mbIcon = { init };

    const REINIT_EVENTS = [
        "shopify:section:load", // New Shopify sections
        "mb:variant:change",    // Your new variant switch event
        "mb:cart:rendered",     // When cart drawer updates
        "mb:cart:changed"       // When items are added
    ];

    REINIT_EVENTS.forEach(eventName => {
        document.addEventListener(eventName, (e) => {
            const root = (e.target instanceof HTMLElement) ? e.target : document;
            requestAnimationFrame(() => init(root));
        });
    });


    // If Shopify updates sections dynamically
    /*    document.addEventListener("shopify:section:load", (e) => init(e.target));
        document.addEventListener("mb:cart:rendered", () => { init() });*/
})();
